<template>
  <section
    class="main-container new-products-home"
    v-if="products && products.length"
  >
    <div id="new-products-slider" class="new-products-slider position-relative">
      <BigTitle class="mb-2 mb-sm-4" title="جدیدترین های آنجل" />

      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide "
            v-for="(product, index) in products"
            :key="index"
          >
            <Product class="w-100" :key="index" :product="product" />
          </div>
        </div>
      </div>
      <div class="text-center">
        <MoreButton to="/products?sort=newest" />
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import BigTitle from "@/parts/Front/nicecomponents/shared/BigTitle";
import MoreButton from "./shared/MoreButton.vue";
import Product from "@/parts/Front/components/product/Product";

import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "newProductsSlider",
  inject: ["mediaQueries"],
  components: {
    MoreButton,
    BSkeletonImg,
    BigTitle,
    Product,
  },

  inject: ["mediaQueries"],

  methods: {
    initNewProducts(kill = false) {
      this.initSwiper("new-products-slider", kill, () => {
        new Swiper("#new-products-slider .swiper-container", {
          spaceBetween: 30,

          loop: true,
          speed: 1400,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: "#new-products-slider .swiper-button-next",
            prevEl: "#new-products-slider .swiper-button-prev",
          },

          breakpoints: {
            300: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            400: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 15,
            },

            1200: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1550: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
          },
        });
      });
    },
    getEnough(array) {
      return [...array].splice(0, Math.min(array.length, this.showCount));
    },
  },
  mounted() {
    this.initNewProducts();
  },
  watch: {
    products() {
      this.initNewProducts();
    },
  },
  computed: {
    showCount() {
      if (this.mediaQueries.xxxLarge) {
        return 10;
      }
      if (this.mediaQueries.xxLarge) {
        return 9;
      }

      return 9;
    },
    products() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return null;
      } else {
        return this.$store.getters["front/getHomeData"].new_products;
      }
    },
  },
};
</script>

<style scoped>
.new-products-home {
  margin-top: 70px;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #e9e9e9;
  transition: all 0.3s;
}

.swiper-button-next {
  right: -20px;
}

.swiper-button-prev {
  left: -20px;
}

.new-products-home .swiper-button-prev:hover,
.new-products-home .swiper-button-next:hover {
  background-color: #000;
}

.new-products-home .swiper-button-prev .bi path {
  stroke-width: 3px;
}

.new-products-home .swiper-button-prev:hover .bi path,
.new-products-home .swiper-button-next:hover .bi path {
  fill: #fff;
}

@media screen and (max-width: 639px) {
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .new-products-home {
    margin-top: 40px;
  }
}
</style>
<style>
.new-products-home .swiper-wrapper {
  padding: 8px 0;
}

.new-products-home .swiper-button-prev:after,
.new-products-home .swiper-container-rtl .swiper-button-next:after,
.new-products-home .swiper-button-next:after,
.new-products-home .swiper-container-rtl .swiper-button-prev:after {
  display: none;
}

@media screen and (max-width: 639px) {
}
</style>
